import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DashboardHeaderNavComponent } from 'app/main/dashboard-header-nav/dashboard-header-nav.component';
import { LoadingComponent } from 'app/main/loading/loading.component';
import { ScrollTopComponent } from 'app/pages/landing/scroll-top/scroll-top.component';
import { HAS_ENTITY_SIDEBAR } from 'shared/interfaces/shared-interfaces';
import { SupportPageContextDirective } from 'shared/core/services/support-page-context.directive';

@Component({
    selector: 'app-header-layout',
    standalone: true,
    imports: [
        RouterOutlet,
        SupportPageContextDirective,
        ScrollTopComponent,
        LoadingComponent,
        DashboardHeaderNavComponent,
    ],
    templateUrl: './header-layout.component.html',
    providers: [{ provide: HAS_ENTITY_SIDEBAR, useValue: false }],
})
export class HeaderLayoutComponent {}
